import React from 'react';
import { Table } from '@/components/ui';
import ServerPagination from '../../../../../components/ServerPagination';

export interface FieldTableProps {
  fields: Array<any>;
  currentPage: number;
  setCurrentPage: (page: number) => void;
  itemsPerPage: number;
  onPageSizeChange: (pageSize: number) => void;
  renderValue?: (field: any) => React.ReactNode;
  /** If set, used for the Field column instead of question || field */
  getFieldLabel?: (field: any) => React.ReactNode;
  disabled?: boolean;
  indent?: boolean;
}

const FieldTable: React.FC<FieldTableProps> = ({
  fields,
  currentPage,
  setCurrentPage,
  itemsPerPage,
  onPageSizeChange,
  renderValue,
  getFieldLabel,
  disabled,
  indent
}) => {
  const totalPages = Math.ceil(fields.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const paginatedFields = fields.slice(startIndex, endIndex);

  return (
    <div className={indent ? 'tw-ml-3' : ''}>
      <div className="tw-overflow-x-auto">
        <Table striped hover size="sm" className="tw-border tw-border-line">
          <colgroup>
            <col style={{ width: '35%' }} />
            <col style={{ width: '65%' }} />
          </colgroup>
          <thead>
            <tr>
              <th scope="col" className="tw-align-middle tw-text-content-secondary tw-py-1">Field</th>
              <th scope="col" className="tw-align-middle tw-text-content-secondary tw-py-1">Value</th>
            </tr>
          </thead>
          <tbody className="tw-text-sm">
            {paginatedFields.map(field => (
              <tr key={field.id} className="tw-py-0">
                <td className="tw-align-middle tw-text-content-muted tw-py-1">
                  {getFieldLabel ? getFieldLabel(field) : field.question || field.field}
                </td>
                <td className="tw-align-middle tw-py-1" title={field.value || '-'}>
                  {renderValue ? renderValue(field) : field.value}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        <ServerPagination
          currentPage={currentPage}
          totalPages={totalPages}
          totalCount={fields.length}
          pageSize={itemsPerPage}
          onPageChange={setCurrentPage}
          onPageSizeChange={onPageSizeChange}
          maxVisiblePages={5}
          className="tw-mt-2"
        />
      </div>
    </div>
  );
};

export default FieldTable; 